import { COOKIES_KEY_PREFIX } from '../../constants';
import { datadogRum } from '@datadog/browser-rum';
import {fetchUserWrapper} from './fetch-user';
import {setUserTokenWrapper} from './set-user-token'
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

/**
 * Checks the SSO session (dedicated flows e.g booking portal) and restores the user state if active.
 * @async
 * @returns {Promise<void>}
 */
export const checkSSOSessionWrapper = async (
  app: Context['app'],
  authInstance: AuthObject
) => {
  const token = app['$cookies'].get(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.token`);
  const expiration = app['$cookies'].get(
    `${COOKIES_KEY_PREFIX}.${authInstance.clientId}.tokenExpiration`
  );
  if (token) {
    try {
      await fetchUserWrapper(
        token,
        app,
        authInstance
      );

      setUserTokenWrapper(
        token,
        expiration,
        app,
        authInstance
      );
    } catch (error) {
      datadogRum.addError("sso_session_check", {
        auth: {
          clientId: authInstance.clientId,
          token,
          expiration,
          isAuthenticated: !!token,
          error
        },
      });
    }

  }
};
